// Generated by tools/generate-avatar-tags.mjs; edit tools/contracts/avatar-tags.cts.
// Generated from tools/contracts/avatar-tags.cts. Do not edit directly.


// Canonical runtime-neutral contract. Generate copies with tools/generate-avatar-tags.mjs.
const TAG_VERSION = 1;
const TAG_LIMIT = 12;
const TAG_GROUPS             = [
  { key: "appearance", label: "形象特征", hint: "与适配角色合计选择5–10项", options: ["现代","商务","时尚","御姐","可爱","甜美","高冷","邻家","灵动","知性","优雅","英气","阳光","亲和","少年感"] },
  { key: "temperament", label: "历史气质", hint: "保留历史资料", options: [] },
  { key: "themes", label: "历史题材", hint: "保留历史资料", options: [] },
  { key: "roleDirections", label: "适配角色", hint: "角色方向不代表本人职业", options: ["职场精英","都市丽人","霸道总裁","霸道女总裁","阳光少年","元气少女","古装美人","二次元","硬汉","成熟大叔"] },
  { key: "contentDomains", label: "历史内容领域", hint: "保留历史资料", options: [] },
  { key: "brandDirections", label: "历史合作方向", hint: "保留历史资料", options: [] },
];
const LEGACY_TAG_GROUPS             = [
  { key: "appearance", label: "外貌风格", hint: "选择形象的视觉特点", options: ["清秀", "高级脸", "少年感", "精致", "气场型", "邻家", "甜美", "英气", "硬朗", "轮廓鲜明", "清爽", "自然素颜", "镜头感", "文艺", "时尚", "商务", "运动感", "复古", "古典", "青春感"] },
  { key: "temperament", label: "气质", hint: "描述形象给人的观感", options: ["温柔", "高冷", "治愈", "元气", "成熟", "清冷", "自然", "知性", "亲和", "沉稳", "干练", "理性", "睿智", "阳光", "幽默", "活泼", "松弛", "优雅", "自信", "坚毅", "内敛", "质朴", "威严", "灵动"] },
  { key: "themes", label: "适合题材", hint: "希望尝试的故事与内容背景", options: ["校园", "都市", "甜宠", "霸总", "悬疑", "古风", "职场", "青春", "家庭", "亲情", "友情", "婚恋", "创业", "律政", "医疗", "金融商战", "生活喜剧", "乡村生活", "旅行", "运动竞技", "美食", "科幻", "奇幻", "年代", "公益", "文化纪实"] },
  { key: "roleDirections", label: "角色方向", hint: "希望尝试的角色，不代表本人真实职业", options: ["职场新人角色", "管理者角色", "创业者角色", "金融从业者角色", "律师角色", "医生角色", "教师角色", "科研人员角色", "工程师角色", "设计师角色", "记者角色", "厨师角色", "运动员角色", "学生角色", "父母角色", "邻里角色", "朋友角色", "恋人角色", "古装人物角色", "喜剧人物角色", "悬疑人物角色", "科幻人物角色"] },
  { key: "contentDomains", label: "内容领域", hint: "本人实际创作的方向，不代表粉丝画像", options: ["财经科普", "法律科普", "职场成长", "商业观察", "科技数码", "汽车出行", "时尚穿搭", "美妆护肤", "家居生活", "亲子育儿", "教育学习", "健康科普", "运动健身", "美食烹饪", "旅行户外", "三农生活", "文化艺术", "影视娱乐", "游戏动漫", "情感沟通", "剧情演绎", "幽默搞笑", "摄影创作", "音乐舞蹈", "宠物生活", "公益科普"] },
  { key: "brandDirections", label: "意向合作行业", hint: "希望洽谈的方向，不代表已有合作或代言", options: ["金融保险", "证券服务", "企业服务", "教育培训", "数码科技", "汽车出行", "家居家电", "食品饮料", "美妆个护", "服饰配饰", "运动户外", "母婴用品", "文旅酒店", "文化出版", "游戏娱乐", "生活服务", "宠物用品", "公益项目"] },
];
const TAG_KEYS = TAG_GROUPS.map(group => group.key);
function existingList(value         )           {
  return Array.isArray(value) ? [...new Set(value.filter(item => typeof item === "string" && item.trim()).map(item => item.trim()))] : [];
}
function readTagProfile(record            = {})                           {
  const tags = existingList(record.tags);
  return Object.fromEntries(TAG_GROUPS.map(group => [group.key,
    Array.isArray(record[group.key]) && ((record[group.key]             ).length || record.tagSchemaVersion === TAG_VERSION)
      ? existingList(record[group.key]) : tags.filter(tag => group.options.includes(tag) || LEGACY_TAG_GROUPS.find(item => item.key === group.key) .options.includes(tag)),
  ]));
}
function tagSections(record            = {}) {
  const profile = readTagProfile(record);
  const grouped = new Set(TAG_KEYS.flatMap(key => profile[key]));
  const legacy = existingList(record.tags).filter(tag => !grouped.has(tag));
  return [...TAG_GROUPS.map(group => ({ key: group.key, label: group.label, hint: group.hint, values: profile[group.key] })),
    { key: "legacy", label: "历史标签", hint: "保留原有资料，待逐项归类", values: legacy }].filter(group => group.values.length);
}
function mergeTagProfile(input            = {}, current            = {}) {
  const profile = readTagProfile(current);
  const previous = new Set(TAG_KEYS.flatMap(key => profile[key]));
  const legacy = existingList(current.tags).filter(tag => !previous.has(tag));
  for (const group of TAG_GROUPS) {
    const value = input[group.key];
    if (value === undefined) continue;
    // Existing values remain editable even when a dictionary entry is retired.
    const allowed = new Set([...group.options, ...LEGACY_TAG_GROUPS.find(item => item.key === group.key) .options, ...profile[group.key]]);
    if (!Array.isArray(value) || value.length > Math.max(TAG_LIMIT, profile[group.key].length)
      || value.some(tag => typeof tag !== "string" || !tag.trim() || tag.trim().length > 12 || !allowed.has(tag.trim()))) {
      throw new Error(`${group.label}请选择有效标签，每组最多 ${TAG_LIMIT} 项`);
    }
    profile[group.key] = existingList(value);
  }
  // Legacy clients may still submit flat tags; these never overwrite structured groups.
  if (input.tags !== undefined) {
    if (!Array.isArray(input.tags) || input.tags.length > 144
      || input.tags.some(tag => typeof tag !== "string" || !tag.trim() || tag.trim().length > 12)) throw new Error("形象标签格式不正确");
    const known = new Set([...TAG_GROUPS, ...LEGACY_TAG_GROUPS].flatMap(group => group.options));
    for (const tag of existingList(input.tags)) {
      if (!known.has(tag) && !existingList(current.tags).includes(tag)) throw new Error("请选择有效形象标签");
      if (!known.has(tag) && !previous.has(tag)) legacy.push(tag);
      for (const group of TAG_GROUPS) {
        if (input[group.key] === undefined && (group.options.includes(tag) || LEGACY_TAG_GROUPS.find(item => item.key === group.key) .options.includes(tag)) && !profile[group.key].includes(tag)
          && profile[group.key].length < TAG_LIMIT) profile[group.key].push(tag);
      }
    }
  }
  const tags = [...new Set([...TAG_KEYS.flatMap(key => profile[key]), ...legacy])];
  if (tags.length > Math.max(144, existingList(current.tags).length)) throw new Error("形象标签总数过多");
  return { ...profile, tags, tagSchemaVersion: TAG_VERSION };
}
export { TAG_VERSION, TAG_LIMIT, TAG_GROUPS, LEGACY_TAG_GROUPS, TAG_KEYS, readTagProfile, tagSections, mergeTagProfile };
